export const V4A_NAMESPACE = 'components/trial/lp/v4a';

export const IMAGE_BASE = '/assets/images/trial/v4a';
export const VIDEO_BASE = '/assets/video/trial/v4a';

/** Anchors the page's CTAs point at when the dialog cannot open (no `showModal`, or a modified click). */
export const HERO_FORM_ANCHOR = 'cadastro';
export const FINAL_FORM_ANCHOR = 'cadastro-final';

export type ChampionSlug = 'coldzera' | 'sacy' | 'brtt';

export interface Champion {
  slug: ChampionSlug;
  /** Player handle: a proper noun, never translated. */
  name: string;
}

/** The lead card rotates in this order; the two small cards always show the other two players. */
export const CHAMPIONS: readonly Champion[] = [
  { slug: 'coldzera', name: 'coldzera' },
  { slug: 'sacy', name: 'Sacy' },
  { slug: 'brtt', name: 'brTT' },
];

/** The hero's avatar row keeps the source's order (Sacy, coldzera, brTT). */
export const HERO_FACES: readonly Champion[] = [CHAMPIONS[1] as Champion, CHAMPIONS[0] as Champion, CHAMPIONS[2] as Champion];

export interface GameCover {
  file: string;
  title: string;
  width: number;
  height: number;
}

/** Cover wall, lane A order. Titles are game names: canonical in every locale. */
export const GAME_COVERS: readonly GameCover[] = [
  { file: 'game-valorant-256', title: 'Valorant', width: 256, height: 341 },
  { file: 'game-cs2-256', title: 'Counter-Strike 2', width: 256, height: 341 },
  { file: 'game-fortnite-256', title: 'Fortnite', width: 256, height: 341 },
  { file: 'game-lol-256', title: 'League of Legends', width: 256, height: 341 },
  { file: 'game-apex-256', title: 'Apex Legends', width: 256, height: 341 },
  { file: 'game-dota2-256', title: 'Dota 2', width: 256, height: 341 },
  { file: 'game-pubg-256', title: 'PUBG', width: 256, height: 341 },
  { file: 'game-tarkov-256', title: 'Escape From Tarkov', width: 256, height: 341 },
  { file: 'game-overwatch2-256', title: 'Overwatch 2', width: 256, height: 341 },
  { file: 'game-r6-248', title: 'Rainbow Six Siege', width: 248, height: 331 },
  { file: 'game-wow-256', title: 'World of Warcraft', width: 256, height: 341 },
  { file: 'game-ffxiv-256', title: 'Final Fantasy XIV', width: 256, height: 341 },
  { file: 'game-ragnarok-256', title: 'Ragnarok', width: 256, height: 341 },
  { file: 'game-tibia-248', title: 'Tibia', width: 248, height: 331 },
  { file: 'game-albion-250', title: 'Albion Online', width: 250, height: 333 },
  { file: 'game-lineage2-256', title: 'Lineage II', width: 256, height: 341 },
  { file: 'game-warface-248', title: 'Warface', width: 248, height: 331 },
  { file: 'game-starcraft-256', title: 'StarCraft', width: 256, height: 341 },
];

/** Lane B carries the same covers rotated by nine, so the two lanes never show a title twice. */
export const GAME_COVERS_LANE_B: readonly GameCover[] = [...GAME_COVERS.slice(9), ...GAME_COVERS.slice(0, 9)];

/** The five titles under the enrolment form (game names, canonical in every locale). */
export const FORM_GAMES = ['Valorant', 'CS2', 'League of Legends', 'Fortnite', 'Apex Legends'] as const;

export const FAQ_COUNT = 6;
